import { useSelector } from 'react-redux';
import { apiService } from '../../../services/api/apiService';
import { Pagination, PaginationFilterDto } from '../../../types/Pagination';
import { AuditLogRequestDto, AuditLogListItem } from '../types';
import { RootState } from '../../../redux/store';
import { ExtractFnReturnType, QueryConfig } from '../../../lib/react-query';
import { useQuery } from '@tanstack/react-query';

const BASE_URL = '/auditlogs';

export const addAuditLog = async (request: AuditLogRequestDto): Promise<void> => {
    try{
        await apiService.post<AuditLogRequestDto, void>(`${BASE_URL}/add`, request);
    }catch(error){
        console.error("Error adding audit log", error);
    }
}; 
    
export const getAuditLogs = async (paginationFilters: PaginationFilterDto): Promise<Pagination<AuditLogListItem>> =>
    await apiService.post<PaginationFilterDto, Pagination<AuditLogListItem>>(`${BASE_URL}/`, paginationFilters)

type QueryFnType = typeof getAuditLogs;

type UseGetAuditLogOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAuditLogs = ({
    config
}: UseGetAuditLogOptions = {}) => {
    const selectedFilters = useSelector((state: RootState) => state.filters.auditLogs.selectedFilters);
    const pagination = useSelector((state: RootState) => state.historical.auditLogs);
  
    const paginationFilters: PaginationFilterDto = 
    {
        pageNumber: pagination.currentPage,
        pageSize: pagination.itemsPerPage,
        search: pagination.searchText,
        filters: selectedFilters,
        selectedOrganizationalStructureIds: []
    };
    
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ['getAuditLogs', selectedFilters, pagination],
        queryFn: () => getAuditLogs(paginationFilters),
    });
}


export const exportAuditLogsToCSV = async (paginationFilters: PaginationFilterDto): Promise<void> => {
    try {        
        const result = await apiService.post<PaginationFilterDto, any>(`${BASE_URL}/exportCsv`, paginationFilters, {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json',
            }
        })

        const fileData = result.data ? result.data : result;

        console.log("File Data Type:", typeof fileData);
        const blob = new Blob([fileData], { type: 'text/csv;charset=utf-8' });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "audit_logs_export.csv";
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error downloading CSV", error);
    }
};
